import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const ConnectSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "ConnectAudienceSettingsPage" */ "@circle-react/components/SettingsApp/Connect/Audience"
    ),
);

export const ConnectAudienceSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <ConnectSettingsComponent />
  </Suspense>
);
